<div class="confirm-password-view">
  <div class="left-section">
    <div class="heading" *ngIf="!setpassword">Reset your password</div>
    <div class="heading" *ngIf="setpassword">Set your password</div>
    <div class="accent-bar" aria-hidden="true"></div>
    <div class="sub-heading">Choose a strong password and confirm it below.</div>

    <form class="forgotpwd-form" [formGroup]="confirmPwdForm" (ngSubmit)="confirmPwdSumbit()">
      <label class="label-txt" for="newPassword">New Password</label>
      <mat-form-field class="input-field" appearance="outline">
        <mat-icon matPrefix>lock</mat-icon>
        <input id="newPassword" type="password" matInput placeholder="Create a secure password"
          formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
        <mat-error *ngIf="submitted && f.password.errors">
          <span *ngIf="f.password.errors.required">Password is required</span>
          <span *ngIf="f.password.errors.minlength">Password must be at least 8 characters</span>
        </mat-error>
      </mat-form-field>

      <label class="label-txt" for="confirmPassword">Confirm Password</label>
      <mat-form-field class="input-field" appearance="outline">
        <mat-icon matPrefix>lock</mat-icon>
        <input id="confirmPassword" type="password" matInput placeholder="Re-enter your password"
          formControlName="confirmPassword" (input)="validateConfirmPassword()" required>
        <mat-error *ngIf="f.confirmPassword?.errors?.mustMatch">
          <span>Passwords must match</span>
        </mat-error>
      </mat-form-field>

      <div class="submit-section">
        <button type="submit" #setPasswordBtn mat-flat-button color="primary" [disabled]="confirmPwdForm.invalid"
          class="submit-btn">
          <span class="btn-spinner" *ngIf="submitted && confirmPwdForm.valid"></span>
          {{ setpassword ? 'Set Password' : 'Reset Password' }}
        </button>
      </div>
    </form>
  </div>

  <div class="right-section">
    <img src="../../../assets/changepassword.svg" alt="Change password illustration" class="illustration" />
  </div>
</div>